import { api } from '@/api';
import { useActionWithConfirmation } from '@/components/confirmationModals/useActionWithConfirmation';

export function useDeleteProtocolEntityWithConfirmation() {
  return useActionWithConfirmation({
    confirmedAction: async (id: string) => await api.protocolsApi.deleteProtocol({ id }),
  });
}
